<template>
  <div>
    <Loading :value="loading"></Loading>
    <v-dialog
      v-model="dialogReserve"
      width="80%"
      :persistent="true"
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>Ajouter une nouvelle reserve pour la tache {{tache ? tache.libelle:"N/A"}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <el-form
            id="formReserve"
            :model="formReserve"
            :rules="rules"
            ref="formReserve"
            class="demo-form-inline"
          >
            <v-layout wrap>
              <v-flex xs12>
                <v-layout row>
                  <v-flex md3>
                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4">
                      <img :src="formReserve.images[0]" alt="avatar" />
                    </v-avatar>
                    <v-layout row>
                      <input
                        name="fileTache"
                        type="file"
                        style="display:none"
                        ref="fileTache"
                        accept="image/*"
                        @change="onFileTachePicked"
                      />
                      <v-tooltip bottom>
                        <v-btn
                          slot="activator"
                          color="primary"
                          class="white--text"
                          required
                          @click.native="$refs.fileTache.click()"
                        >
                          Image 1
                          <v-icon right dark>cloud_upload</v-icon>
                        </v-btn>
                        <span>Taille inférieur à 1024 ko</span>
                      </v-tooltip>
                    </v-layout>
                  </v-flex>
                  <v-flex md3>
                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4">
                      <img :src="formReserve.images[1]" alt="avatar" />
                    </v-avatar>
                    <v-layout row>
                      <input
                        name="fileTache2"
                        type="file"
                        style="display:none"
                        ref="fileTache2"
                        accept="image/*"
                        @change="onFileTachePicked2"
                      />
                      <v-tooltip bottom>
                        <v-btn
                          slot="activator"
                          color="primary"
                          class="white--text"
                          required
                          @click.native="$refs.fileTache2.click()"
                        >
                          Image 2
                          <v-icon right dark>cloud_upload</v-icon>
                        </v-btn>
                        <span>Taille inférieur à 1024 ko</span>
                      </v-tooltip>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12>
                <el-form label-position="top" :inline="true" class="demo-form-inline">
                  <v-flex xs12>
                    <el-form-item prop="description" style="width:100%" label="Description">
                      <el-input
                        style="width:100%"
                        type="textarea"
                        :rows="6"
                        placeholder="Description brève "
                        v-model="formReserve.description"
                      ></el-input>
                    </el-form-item>
                  </v-flex>
                </el-form>
              </v-flex>
            </v-layout>
          </el-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click.native="dialogReserve = false">Annuler</v-btn>
          <v-btn color="green darken-1" flat="flat" @click.native="createReserve()">Enregistrer</v-btn>
        </v-card-actions>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "AjoutReserve",
  props: {
    show: {
      type: Boolean
    },
    tache: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

      loading: false,
      dialogReserve: false,
      formReserve: {
        description: null,
        images: []
      },
      fichierImage: [],
      rules: {
        description: [{ required: true, message: "Veuillez saisir" }]
      }
    };
  },

  watch: {
    show: function(newValue, oldvalue) {
      if (newValue == false) {
        this.dialogReserve = false;
      }
      else{
           this.dialogReserve = true;
           this.resetForm("formReserve")
      }
    },
 },

    methods: 
    {
      createReserve() {

        this.$refs["formReserve"].validate(valid => {
          if (valid) {
            this.loading = true;
            let url = this.domaine + "reserve/new";
            let data = new FormData();
            data.append("idOptTrx", this.tache.idOptTrx);
            data.append("description", this.formReserve.description);
            data.append("idUser", this.user.id);

            if (this.fichierImage.length > 0) {
              this.fichierImage.forEach(file => {
                data.append("fichierImage[]", file, file[name]);
              }, this);
            }

            this.$http.post(url, data).then(
              resp => {
                this.loading = false;
                //this.dialogAccord = false;
                this.$notify({
                  title: "Reserve",
                  message: "Reserve enregistrée",
                  type: "success",
                  position: "top-right",
                  duration: 7000
                });

                this.formReserve.images.splice(0);
                this.fichierImage.splice(0);
                this.closeDialog();
              },
              resp => {
                this.loading = false;
                this.$message.error(
                  "Erreur lors de l'enregistrement d'une reserve"
                );
              }
            );
          }
        });
      },

      onFileTachePicked(event) {
        this.formReserve.images.splice(0, 1);
        this.fichierImage.splice(0, 1);
        const files = event.target.files;
        let filename = files[0].name;
        if (filename.lastIndexOf(".") <= 0) {
          return alert("Veuillez selectionner un  format de fichier valide ");
        }
        if (files[0].size > 1048576) {
          this.$message.error("La taille du fichier est supérieur à 1024 ko");
          return;
        }

        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.formReserve.images.push(fileReader.result);
        });

        fileReader.readAsDataURL(files[0]);

        this.fichierImage.push(files[0]);
      },

      onFileTachePicked2(event) {
        this.formReserve.images.splice(1, 1);
        this.fichierImage.splice(1, 1);
        const files = event.target.files;
        let filename = files[0].name;
        if (filename.lastIndexOf(".") <= 0) {
          return alert("Veuillez selectionner un  format de fichier valide ");
        }
        if (files[0].size > 1048576) {
          this.$message.error("La taille du fichier est supérieur à 1024 ko");
          return;
        }

        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.formReserve.images.push(fileReader.result);
        });

        fileReader.readAsDataURL(files[0]);

        this.fichierImage.push(files[0]);
      },
     closeDialog() {
        this.$emit("close");
      },

      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.formReserve.images.splice(0)
        this.formReserve.description = "";
      }
    }
 
};
</script>



// WEBPACK FOOTER //
// src/components/rapport/AjoutReserve.vue